export const PASSWORD_CHANGE_FLOW_KEY = 'dmPasswordChangeFlow';
